<template>
  <BaseLink
    v-editable="blok"
    class="link"
    :target="blok.address && blok.address.target"
    :class="{
      'link--animated-arrow': blok.animated_arrow,
    }"
    :address="blok.address || {}"
  >
    {{ blok.text }}
    <span v-if="blok.animated_arrow" class="link__arrow">→</span>
  </BaseLink>
</template>

<script lang="ts" setup>
import type { SbLinkStoryblok } from '@/types'

interface Props {
  blok: SbLinkStoryblok
}
defineProps<Props>()
</script>
<style lang="scss" scoped>
.link {
  &--in-list {
    margin-right: 30px;
    margin-bottom: 20px;
  }
  &--animated-arrow {
    color: var(--color-text) !important;
    text-decoration: none !important;

    .link__arrow {
      color: var(--color-link);
      position: absolute;
      transition: transform 0.2s ease-out;
      margin-left: 5px;
    }

    &:hover .link__arrow {
      transform: translateX(10px);
    }
  }
}
</style>
